
export interface IError{
    error:string;
    codes?:number[];
}

export class ApiErrors{

    static LOADING:IError =             {error:"Error Loading"};
    static SYSTEM:IError =              {error:"System Error", codes:[503]};
    static SAVING:IError =              {error:"Error Saving"};
    static UNKNOWNUSER:IError =         {error:"Unknown User", codes:[502]};
    static INVALIDTOKEN:IError =        {error:"Your session has expired or become invalid.", codes:[81]};
    static INVALIDCREDS:IError =        {error:"Incorrect Credentials", codes:[12]};
    static INVALIDUSERRIGHTS:IError =   {error:"Invalid User Rights"};
    static ACCESS:IError =              {error:"Access Permission Error", codes:[501]};
    static INVALIDAPPVERSION:IError =   {error:"Invalid App Version"};
    static NORECENTCALLHISTORY:IError = {error:"No Recent Call History", codes:[80]};

    //unique identifies for our own custom google errors
    static GM_GEOCODE_FAIL:IError = {error:"Failed to find a Location"};
    static GM_NO_PLACES_SERVICE:IError = {error:"No Places Service Available"};
    static GM_PLACES_ERROR:IError = {error:"Failed finding Place"};
    static GM_SEARCH_ERROR:IError = {error:"Failed searching Place"};

    static ERROR_CODES:IError[] = [
        ApiErrors.SYSTEM,
        ApiErrors.UNKNOWNUSER,
        ApiErrors.INVALIDTOKEN,
        ApiErrors.INVALIDCREDS,
        ApiErrors.ACCESS,   
    ];
    
    static FORCE_LOGOUT_ERROR_CODES:IError[] = [
        ApiErrors.UNKNOWNUSER,
        ApiErrors.INVALIDTOKEN,
        ApiErrors.ACCESS,        
    ];

    static CALL_HISTORY_ERROR_CODES:IError[] = [
        ApiErrors.NORECENTCALLHISTORY,
    ];

    static findErrorWithCode($code:number,$codes:IError[] = ApiErrors.ERROR_CODES){
        let error:IError | undefined = this.ERROR_CODES.find(($error)=>{
            let match:boolean=false;

            if($error.codes){
                let code = $error.codes.find(($errorCode)=>{
                    return $code.toString()===$errorCode.toString();
                });
                if(code){
                    match=true;
                }
            }
            return match;
        });
        return error;
    }
}
